import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AgendamentoDespesaListarComponent } from './agendamento-despesa-listar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: AgendamentoDespesaListarComponent }
    ])],
    exports: [RouterModule]
})
export class AgendamentoDespesaListarRoutingModule { }
